export const OPTIMIZELY_ROUTE_FLAGS: Record<string, string[]> = {
  "/": ["AS202"],
};
